import React from "react"

const TextInput = ({
  containerStyle,
  isPhoneNumber = false,
  error = "",
  icons,
  ...props

}) => {
  return (
    <>
      <div
        className={`flex flex-row flex-1 py-[16px] px-[12px] md:px-[20px] md:py-[20px] border-[1px] rounded-[10px] border-[#42495233] relative bg-[#42495208] ${containerStyle}`}
      >
        {isPhoneNumber ? <span className="mr-[10px]">+91</span> : <></>}{" "}
        <input {...props} className={`bg-[transparent] font-Apparat font-[500] text-[14px] md:text-[20px] leading-[20.44px] md:leading-[32px] ${props?.className} `} />
        <div className="absolute bottom-4  md:bottom-5 right-2">
          {icons}
        </div>
      </div>
      {error ? (
        <p className="text-red-500 text-[12px] mt-[8px]">{error}</p>
      ) : null}
    </>
  )
}

export default TextInput
